<template>
  <div>
    <v-list class="subscriptions_list pb-0" v-if="subscriptionsList">
      <div class="hidden-sm-and-down">
        <v-list-tile>
          <v-layout row px-2 align-center class="caption">
            <v-flex xs3 class="font-weight-medium">
              Numer faktury
            </v-flex>
            <v-flex xs3 class="font-weight-medium">
              Okres rozliczenia
            </v-flex>
            <v-flex xs2 class="font-weight-medium">
              Zapłacone
            </v-flex>
            <v-flex xs3 class="font-weight-medium">
              Dostępne miejsce
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-divider></v-divider>
      </div>
      <SubscriptionsItem
        v-for="(subscription, i) in subscriptionsList"
        :key="i"
        :index="i"
        :subscription="subscription" />
        <div v-if="subscriptionsList && subscriptionsList.length === 0" class="px-4 py-4">
          <p class="mb-0 grey--text text--darken-1 subheading font-weight-bold">
            Brak historii rozliczeń dla podanego klienta
          </p>
        </div>
    </v-list>
    <SubscriptionDelete />
    <SubscriptionAdd />
    <SubscriptionEdit />
    <div class="users_loader" v-if="!subscriptionsList">
      <div class="py-4 text-xs-center">
        <v-progress-circular
          :size="30"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SubscriptionsItem from './SubscriptionsItem.vue';
import SubscriptionDelete from './Dialogs/SubscriptionDeleteDialog.vue';
import SubscriptionAdd from './Dialogs/SubscriptionAddDialog.vue';
import SubscriptionEdit from './Dialogs/SubscriptionEditDialog.vue';

export default {
  name: 'subscriptions-list',
  components: {
    SubscriptionsItem,
    SubscriptionDelete,
    SubscriptionAdd,
    SubscriptionEdit,
  },
  computed: {
    ...mapGetters('subscriptions', [
      'subscriptionsList',
    ]),
    userId() {
      return this.$route.params.id;
    },
  },
  methods: {
    ...mapActions('subscriptions', [
      'getSubscriptionsList',
    ]),
    async getList() {
      await this.getSubscriptionsList(this.userId);
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
